export function confirmWorkflowValidationAction(
  onOpenChange: (open: boolean) => void,
  onConfirm: () => void
) {
  onOpenChange(false)
  onConfirm()
}

export async function runWorkflowValidationWarningAction(
  onOpenChange: (open: boolean) => void,
  action: () => Promise<void>
) {
  onOpenChange(false)
  try {
    await action()
  } finally {
    onOpenChange(false)
  }
}
